import { Key } from "ts-keycode-enum";

const alphanumericOnlyDirective = {
    created(element: HTMLInputElement) {
        if (!!element) {
            element.onkeydown = (e) => {
                return checkIfEnteredKeyIsAlphanumeric(e);
            };
        }
    }
};

function checkIfEnteredKeyIsAlphanumeric(e: KeyboardEvent): boolean {
    const keyCode = e.keyCode || e.which;

    const cutCopyPaste = e.ctrlKey && (keyCode === Key.C || keyCode === Key.V || keyCode === Key.X);
    if (cutCopyPaste) return true;

    const isLetter = keyCode >= Key.A && keyCode <= Key.Z;
    const isDigit = (keyCode >= Key.Zero && keyCode <= Key.Nine) || (keyCode >= Key.Numpad0 && keyCode <= Key.Numpad9);
    const isNavigationOrEditingKey =
        keyCode === Key.Backspace ||
        keyCode === Key.Delete ||
        keyCode === Key.LeftArrow ||
        keyCode === Key.RightArrow ||
        keyCode === Key.Tab ||
        keyCode === Key.Space;

    if (isLetter || isDigit || isNavigationOrEditingKey) {
        return true;
    }

    return false;
}

export const alphanumericOnlyDirectives = {
    "alphanumeric-only": alphanumericOnlyDirective
};
